import { PageHeader } from '@@/PageHeader';

import { PoliciesDatatable } from './PoliciesDatatable/PoliciesDatatable';

export function ListView() {
  return (
    <>
      <PageHeader title="Policies" breadcrumbs="Policy management" reload />

      <PoliciesDatatable />
    </>
  );
}
